import { Link } from 'react-router-dom';

import { ContactForm } from '@/components/contact-form';
import { DynamicText } from '@/components/dynamic-text';

const FAQ = [
  {
    q: 'How do I add my partner?',
    a: 'Tap “Invite co-parent” and send them the invite code. They enter it when they sign up, and every child in your family appears on their phone.',
  },
  {
    q: 'My co-parent’s entries are not showing up.',
    a: 'Syncing requires a network connection. Opening Bramble on both phones forces an immediate sync.',
  },
  {
    q: 'Can you recover my data?',
    a: 'Sometimes. Your records are stored on our servers, so losing a phone does not lose your log — sign in again and it comes back. Data you delete yourself is gone permanently, and we cannot undo that.',
  },
  {
    q: 'Is there an Android version?',
    a: 'Not yet. Bramble is currently iOS-only, though the API it syncs through is not iOS-specific.',
  },
];

export default function SupportPage() {
  return (
    <div className="container py-16 sm:py-24">
      <header className="max-w-[62ch]">
        <p className="kicker">
          <DynamicText path="support.kicker">Support</DynamicText>
        </p>
        <h1 className="mt-4 text-[clamp(2.4rem,6vw,3.8rem)] leading-[1.02]">
          <DynamicText path="support.title">Need help? Send us a message.</DynamicText>
        </h1>
        <p className="mt-6 text-lg leading-relaxed text-foreground/80">
          <DynamicText path="support.description">
            No ticketing system. Submissions go straight to our inbox. If you are writing about your
            account, use the email address it is registered to.
          </DynamicText>
        </p>
      </header>

      <div className="hairline my-12" />

      <div className="grid gap-16 lg:grid-cols-[minmax(0,1fr)_minmax(0,22rem)] lg:gap-20">
        <section aria-labelledby="contact-heading">
          <h2 id="contact-heading" className="sr-only">
            <DynamicText path="support.contact_heading">Contact form</DynamicText>
          </h2>
          <div className="max-w-xl">
            <ContactForm />
          </div>
        </section>

        <aside className="space-y-10">
          <section aria-labelledby="faq-heading">
            <h2 id="faq-heading" className="kicker">
              <DynamicText path="support.faq_heading">Before you write</DynamicText>
            </h2>
            <dl className="mt-5 space-y-6">
              {FAQ.map((item) => (
                <div key={item.q} className="border-t border-border pt-5">
                  <dt className="font-display text-lg font-semibold leading-snug">{item.q}</dt>
                  <dd className="mt-1.5 text-[0.95rem] leading-relaxed text-muted-foreground">
                    {item.a}
                  </dd>
                </div>
              ))}
            </dl>
          </section>

          <section className="rounded-lg border border-border bg-card p-6">
            <h2 className="font-display text-lg font-semibold">
              <DynamicText path="support.safety_heading">Data safety note</DynamicText>
            </h2>
            <p className="mt-2 text-[0.95rem] leading-relaxed text-muted-foreground">
              Please do not include medical details about your child in support messages. See the{' '}
              <Link to="/privacy">privacy policy</Link>.
            </p>
          </section>
        </aside>
      </div>
    </div>
  );
}
